<div class="dialog yoodli-reg-confirmation">
    <div mat-dialog-title class="dialog-title">
        <span #dialogTitle id="yoodli-reg-confirmation-title" tabindex="-1" role="heading" aria-level="1">Confirm MCT Renewal Assessment Registration</span>
        <mat-icon class="close-icon" (click)="cancel()" aria-label="Close">close</mat-icon>
    </div>
    <mat-divider></mat-divider>
    <mat-dialog-content>
        <p>By selecting <strong>Yes</strong>, you acknowledge and agree that:</p>
        <ul>
            <li>You did not meet the 6-session renewal requirement for this renewal cycle.</li>
            <li>You are electing to pursue renewal through the MCT Renewal Assessment instead.</li>
            <li>You will no longer be eligible to renew by subsequently meeting the 6-session requirement for this renewal cycle.</li>
            <li>You must pass the MCT Renewal Assessment on your first attempt to qualify for renewal.</li>
            <li>If you do not pass the assessment in your first attempt, your MCT status will lapse and you will need to re-enter the program through the fee-based MCT Instructional Skills Assessment pathway.</li>
        </ul>
        <p>Do you wish to continue with registration for the MCT Renewal Assessment?</p>
        <p>
            <strong>Please Note:</strong>: If you do not have access to the email address associated with your MCT ID 
                                            (the email used to log into this portal) or would like your assessment to be sent to a 
                                            different email DO NOT PROCEED. Instead, email 
                                            <a aria-label="Email MCT Support at mctprog@microsoft.com" href="mailto:mctprog@microsoft.com">mctprog&#64;microsoft.com</a>
                                            with your MCT ID and the address at which you would like the assessment sent.
        </p>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-flat-button class="flat-button" (click)="cancel()">No</button>
        <button mat-flat-button class="flat-button" color="primary" (click)="confirm()">Yes</button>
    </div>
</div>
